import {AxiosInstance} from "axios";
import Utility from "../model/utility/Utility";

export default class UtilityApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	fetchUtilities(): Promise<Utility[]> {
		const url = `/api/web/utilities`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Utility.fromJson));
	}

	createUtility(data: Utility): Promise<Utility> {
		const url = `/api/web/utilities`;
		return this.axiosInstance.post(url, data.toJson()).then(resp => Utility.fromJson(resp.data));
	}

	updateUtility(utilityId: string, data: Utility): Promise<Utility> {
		const url = `/api/web/utilities/${utilityId}`;
		return this.axiosInstance.put(url, data.toJson()).then(resp => Utility.fromJson(resp.data));
	}

	deleteUtility(utilityId: string): Promise<void> {
		const url = `/api/web/utilities/${utilityId}`;
		return this.axiosInstance.delete(url);
	}
}